import cookie from "react-cookies";


export function storagePrefix() {
    let hostname = window.location.hostname;
    return cookie.load("baseUrl" + hostname) === "/" ? "" : cookie.load("baseUrl" + hostname) + "/";    
}
